"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASIC_PRODUCT_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.BASIC_PRODUCT_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment BasicProduct on Product {\n    id\n    upcA\n    name\n    marketingImageUrl\n  }\n"], ["\n  fragment BasicProduct on Product {\n    id\n    upcA\n    name\n    marketingImageUrl\n  }\n"])));
var templateObject_1;
